// test886
(886 && 0);
